import { getStoredAdminPassword } from "../stores/adminAccessStore";
import { requiredEnvVars } from "./env";

interface DownloadParticipantExportParams {
    studyNumber: number;
    startDate: string;
    endDate: string;
}

function padStudyNumber(studyNumber: number): string {
    return String(studyNumber).padStart(2, "0");
}

export async function downloadParticipantExport({
    studyNumber,
    startDate,
    endDate,
}: DownloadParticipantExportParams): Promise<void> {
    const adminPassword = getStoredAdminPassword();
    if (!adminPassword) {
        throw new Error("Admin password required. Please unlock the admin area first.");
    }

    const response = await fetch(`${requiredEnvVars.VITE_SUPABASE_URL}/functions/v1/export-participant-data`, {
        method: "POST",
        headers: {
            apikey: requiredEnvVars.VITE_SUPABASE_ANON_KEY,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            adminPassword,
            startDate,
            endDate,
            studyNumber,
        }),
    });

    if (!response.ok) {
        let message = "Failed to download participant data.";
        try {
            const payload = (await response.json()) as { error?: string };
            if (payload.error) {
                message = payload.error;
            }
        } catch {
            // Keep default message when response is not JSON.
        }
        throw new Error(message);
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `SEAGM_${padStudyNumber(studyNumber)}_diary.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
